<template>
  <div class="container mt-5">
    <div class="section-title">
      <h2>Oncology Department</h2>
      <p>
        The Department of Oncology provides comprehensive cancer care through
        prevention, diagnosis, treatment, and rehabilitation services. Our
        highly skilled oncologists, radiologists, and surgeons work
        collaboratively to ensure the best outcomes for patients with different
        types of cancers.
      </p>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <img
          src="@/assets/img/departments/Oncology.jpg"
          alt="Oncology Department"
          class="img-thumbnail img-thumbnail-box"
        />
      </div>
      <div class="col-lg-8">
        <p><strong>Department of Oncology</strong></p>
        <p>
          The department offers chemotherapy, radiation therapy, targeted
          therapy, and immunotherapy following international evidence-based
          protocols. Our facilities include a well-equipped chemotherapy suite,
          advanced diagnostic imaging, and pathology support for accurate
          staging and treatment planning.
        </p>
        <p>
          A strong emphasis is placed on pain management, nutritional support,
          and psychological counseling to address the physical and emotional
          aspects of cancer. Post-treatment follow-up and palliative care are
          integral to our approach, ensuring continuity of care and quality of
          life for patients.
        </p>
        <p>
          Regular cancer screening and awareness programs are also conducted to
          promote early detection and prevention.
        </p>
      </div>
    </div>
  </div>
  <DoctorsList :name="name" :queryName="queryName" :teamName="teamName" />
</template>

<script lang="ts">
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate2.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Oncology Doctors',
      queryName: 'Oncology',
      teamName: 'Oncology team',
    };
  },
  components: { DoctorsList },
});
</script>

<style scoped lang="scss">
@import '@/scss/sectionTemplate2.scss';
</style>
